import { GenericTable } from '@shared/components/GenericTable';
import { TableAction, TableColumn } from '@shared/types/table';
import { PAGE_SIZE } from '@shared/utils/constants';
import { Download, DownloadIcon, EyeIcon } from 'lucide-react';
import React from 'react'

function PaymentHistory({paymentHistory}) {
    const columns: TableColumn[] = [
    {
      key: "paymentDate",
      header: "Date",
      type: "custom",
    },
    { key: "paymentId", header: "Payment ID", type: "text" },
    {
      key: "receiptNumber",
      header: "Receipt No",
      type: "text",
    },
    {
      key: "channel",
      header: "Channel",
      type: "text",
    },
    {
      key: "paymentMode",
      header: "Mode",
      type: "text",
    },
    {
      key: "amount",
      header: "Amount",
    },
  ];

  const actions: TableAction[] = [
      {
        label: "View Bill",
        icon: <EyeIcon size={20} className="text-gray-500" />,
        onClick: (row) => {},
      },
      {
        label: "Download",
        icon: <DownloadIcon size={20} className="" />,
        onClick: (row) => {},
      }
    ];
  const handlePageChange = (p: number) => {};
  const handleSearch = (search: string) => {};

  return (
      <GenericTable
        data={paymentHistory ?? []}
        columns={columns}
        rowKey="id"
        // pagination={{
        //   currentPage,
        //   totalPages,
        //   totalItems,
        //   itemsPerPage: pageSize,
        //   startItem: (currentPage - 1) * pageSize + 1,
        //   endItem: Math.min(currentPage * pageSize, totalItems),
        // }}
        pagination={{
          currentPage: 1,
        //   totalPages,
        totalPages: 10,
        //   totalItems,
        totalItems: 10,
          itemsPerPage: PAGE_SIZE,
          startItem: (1 - 1) * PAGE_SIZE + 1,
          endItem: Math.min(1 * PAGE_SIZE, 10),
        }}
        actions={actions}
        onPageChange={handlePageChange}
        onSearch={handleSearch}
        searchPlaceholder="Search by Payment ID or receipt number..."
        emptyMessage="No Data Found."
        loading={false}
      />
    );
}

export default PaymentHistory